import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FavoriteIcon from '../icons/FavoriteIcon'
import CartIcon from '../icons/CartIcon'

import axios from 'axios'

import Breadcrumbs from './../block/Breadcrumbs'
import LegalCartItem from './../block/LegalCartItem'

import { Container, Image, Spinner, Button } from 'react-bootstrap'

import styles from './../style/Korzina.module.scss'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      products: [],
      count: 0,
      sum: 0,
      sort: true,
      certificate: false,
      inputCounts: {} // Добавлено для хранения временных значений input
    }
  }

  formatPrice(price) {
    return this.priceFormat(price) + ' ₽'
  }

  priceFormat(price, delimiter = '', fraction = '') {
    if (!price && price !== 0) return 'Цена не указана'
    
    const numericPrice = typeof price === 'number' ? price : parseFloat(price)
    
    return numericPrice.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  normalize_count_form = (number, words_arr) => {
    number = Math.abs(number)
    if (Number.isInteger(number)) {
      let options = [2, 0, 1, 1, 1, 2]
      return words_arr[(number % 100 > 4 && number % 100 < 20) ? 2 : options[(number % 10 < 5) ? number % 10 : 5]]
    }
    return words_arr[1]
  }

  getCart = () => {
    const { cart, addTocart } = this.props

    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'get_cart_data',
      'cart': JSON.stringify( cart )
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      var fined = false
      cart.map( ( product ) => {
        fined = false
        response.data.products.map( ( in_cart ) => {
          if( product.product == in_cart.product ) {
            fined = true
          }
        } )
        if( !fined ) {
          addTocart({
            product: product.product,
            count: 0
          })
        }
      } )
      this.setState({
        loaded: true,
        products: response.data.products,
        count: response.data.count,
        sum: response.data.sum,
        certificate: response.data?.certificate || false,
        inputCounts: response.data.products.reduce((acc, product) => {
          acc[product.id] = product.count;
          return acc;
        }, {})
      })
    })
  }

  changeCount = ( product, count ) => {
    const { addTocart } = this.props,
    main = this

    addTocart({
      resource: product.product,
      product: product.product,
      variant: null,
      count: count
    }, () => {
      main.getCart()
    })
  }

  componentDidMount() {
    this.getCart()
  }

  render() {

    const { ajax_data, data, favorite, changeFavorite, user_profile_type, cart, addTocart } = this.props,
    { loaded, products, count, sum, sort, certificate } = this.state

    if(ajax_data != null) return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <>
              <Breadcrumbs
                items={[
                  {
                    id: 99,
                    pagetitle: ajax_data.pagetitle,
                    is_current: true
                  }
                ]}
              />
              <div className={styles.korzina}>
                <Container className={styles.container}>
                  <h1>Корзина</h1>
                  <div className='d-flex flex-column flex-lg-row align-items-start justify-content-between'>
                    <div className={styles.korzina_flex}>
                      {loaded ?
                        <>
                          {products.length > 0 ?
                            <div className={styles.korzina_list}>
                              {products.sort((a, b) =>
                                a.id > b.id == sort ? 1 : -1,
                              ).map( ( product, k ) => {
                                if( user_profile_type == `legal` ) return (
                                  <LegalCartItem key={k} product={product} cart={cart} addTocart={addTocart} getCart={this.getCart} />
                                )
                                return (
                                  <div className={styles.korzina_list_elm_full} key={k}>
                                    <div className={styles.korzina_list_elm_mobtop}>
                                      {product.image != null &&
                                        <a href={product.url}>
                                          <Image alt={product.name} src={product.image} width="96" height="96" />
                                        </a>
                                      }
                                      <div className='d-flex'>
                                        <div className={styles.korzina_list_elm_btns_mob}>
                                          <div className={styles.korzina_list_elm_btns_elm} onClick={() => this.changeCount( product, 0 )}>
                                            <CartIcon />
                                          </div>
                                          <div className={styles.korzina_list_elm_btns_elm} onClick={() => changeFavorite( product.id )}>
                                            <FavoriteIcon isFavorite={favorite.includes( product.id )} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ flex: 1 }} className='d-flex'>
                                      {product.image != null &&
                                        <a href={product.url}>
                                          <Image alt={product.name} className={styles.korzina_list_elm_image} src={product.image} width="71" height="71" />
                                        </a>
                                      }
                                      <div className={styles.korzina_list_elm_content}>
                                        <div className={styles.korzina_list_elm_art + ` d-none d-md-block`}>Арт. {product.article}</div>
                                        <div className={styles.korzina_list_elm_art + ` d-md-none`}>Арт. {product.article}</div>
                                        <div className={styles.korzina_list_elm_name}>{product.name}</div>
                                        <div className={styles.korzina_list_elm_art + ` d-md-none`}>{product.vendor}</div>
                                        <div className={styles.korzina_list_elm_btns}>
                                          <div className={styles.korzina_list_elm_vendor}>{product.vendor}</div>
                                          <div className={styles.korzina_list_elm_btns_elm} onClick={() => this.changeCount( product, 0 )}>
                                            <CartIcon />
                                          </div>
                                          <div className={styles.korzina_list_elm_btns_elm} onClick={() => changeFavorite( product.id )}>
                                            <FavoriteIcon isFavorite={favorite.includes( product.id )} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.korzina_list_elm_price_block}>
                                      <div className={styles.korzina_list_elm_price}>{this.priceFormat(product.price)} x {product.count} = {this.priceFormat(product.price * ( product.count > 1 ? product.count : 1 ) )} ₽</div>
                                      <div style={{ flex: 1 }}></div>
                                      <div className={styles.korzina_list_elm_count}>
                                        <svg onClick={() => this.changeCount( product, product.count > 1 ? product.count - 1 : 1 )} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
                                          <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" stroke-linecap="round"/>
                                        </svg>
                                        <input className={styles.korzina_list_elm_count_input} type='text' value={this.state.inputCounts[product.id] || product.count} onChange={(e) => this.setState({ inputCounts: { ...this.state.inputCounts, [product.id]: e.target.value } })} onBlur={() => { const newCount = Number(this.state.inputCounts[product.id] || product.count); if (newCount >= 1) { this.changeCount(product, newCount); } else { this.setState({ inputCounts: { ...this.state.inputCounts, [product.id]: product.count } }); } }} />
                                        <svg onClick={() => this.changeCount( product, 99999 > product.count ? product.count + 1 : 99999 )} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
                                          <path d="M12.75 7.5V18" stroke="#1E9FF6" stroke-linecap="round"/>
                                          <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" stroke-linecap="round"/>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          :
                            <div style={{ height: `156px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                              <p>Добавьте товары в корзину</p>
                            </div>
                          }
                        </>
                      :
                        <div style={{ height: `156px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                          <Spinner animation="grow" variant="dark" />
                        </div>
                      }
                    </div>
                    <div className={styles.korzina_rchast}>
                      <div className={styles.korzina_rchast_plashka}>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className={styles.korzina_rchast_title}>ВАШ ЗАКАЗ</div>
                          <div className={styles.korzina_rchast_count}>{count} {this.normalize_count_form( count, [ 'товар', 'товара', 'товаров' ] )}</div>
                        </div>
                        <div className={styles.korzina_rchast_text}>Доступные способы доставки можно выбрать при оформлении заказа</div>
                        <div className={styles.korzina_rchast_sep}></div>
                        {count > 0 &&
                          <>
                            <div className={styles.korzina_rchast_sum}>
                              <div>Итого:</div>
                              <div>{this.priceFormat(sum)} ₽</div>
                            </div>
                            <Button href={ajax_data.oformlenie_lnk} className={`w-100`} variant='primary'>
                              <div className='text-white'>Перейти к оформлению</div>
                            </Button>
                          </>
                        }
                      </div>
                      {certificate &&
                        <div className={styles.korzina_rchast_tru}>
                          <div>В корзине есть товары с кодом ТРУ</div>
                          <div className={styles.korzina_rchast_tru_sep}></div>
                          <a href={data.page_data?.link_sertpage}>Подробнее →</a>
                        </div>
                      }
                      <div className={styles.korzina_rchast_katalog}>
                        <a href={data.page_data?.link_catalog}>Вернуться за покупками</a>
                      </div>
                    </div>
                  </div>
                </Container>
              </div>
            </>
          }
        </div>
      </>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string
}